export var ErrorType;
(function (ErrorType) {
    ErrorType["deviceOffline"] = "DeviceOffline";
    ErrorType["openCell"] = "OpenCell";
    ErrorType["invalidCode"] = "InvalidCode";
})(ErrorType || (ErrorType = {}));
